import React, { useState } from 'react'
import PackageGroup from '../PackageGroup/PackageGroup'
import SubscriptionIntro from '../SubscriptionIntro/SubscriptionIntro'
import bigLogo from '../../assets/sushiroll_logo.svg'
import styles from './VideoPlayer.module.css'

export default function PlayerSubscription({ onDismissPlayer, otherProps, error }) {
  const [subscriptionShow, setSubscriptionShow] = useState(false)
  const goSubscribe = () => {
    setSubscriptionShow(true)
  }

  const goPackGroup = (id) => {
    const { history } = otherProps
    history.push(`/package-group/${id}`)
  }

  const goRedeem = () => {
    const { history } = otherProps
    history.push('/voucher')
  }
  let content = <p>{`${error.message} (# ${error.code})`}</p>
  //does not have video asset
  if (error.code === 'missing_video') {
    content = <p>{`${error.message}`}</p>
  }

  //not subscribed
  if (error.code === 'gfc4030205') {
    const packageGroups = error.details.filter(packGroup => {
      const packages = packGroup.packages.filter(pack => {
        const payments = Object.entries(pack.payments).filter(([key, value]) => {
          return (key.substr(0, 5) === 'telco') && value.description
        })

        return payments.length > 0
      })

      return packages.length > 0
    })

    content = (
      <div className={styles.subscriptionError}>
        <img src={bigLogo} alt='big-logo' />
        <p>You need to subscribe to watch this premium content</p>
        <SubscriptionIntro />
        {packageGroups.length === 0 ?
          <p className={styles.subscriptionList}>This content is not available for your operator</p> :
          <div className={subscriptionShow ? styles.hidden : styles.subscriptionList}>
            <button className={styles.subscribeButton} onClick={goSubscribe}>
              Pick subscription plan
                </button>
          </div>
        }

        <div className={!subscriptionShow ? styles.hidden : styles.subscriptionList}>
          {packageGroups.map(packGroup =>
            <PackageGroup
              key={packGroup.id}
              packGroup={packGroup}
              onClick={goPackGroup}
            />
          )}
        </div>
        <span className={styles.redeemtion} onClick={goRedeem}>
          Have a voucher? Redeem now.
            </span>
      </div>
    )
  }
  return (
    <div className={styles.errorWrapper}>
      <div onClick={onDismissPlayer}>
        <i className='vjs-dismiss-player-icon' />
      </div>
      {content}
    </div>
  )
}